import React, { useContext, useEffect } from 'react';

import { GramUnits, IEUnits, MolUnits, UnitType } from '../../../types';

import CalculatorComponent from '../../../components/CalculatorComponent';

import { CalculatorNavigationContext } from '../../../contexts/CalculatorNavigationProvider';
import { PillsContext } from '../../../contexts/PillsProvider';
import { CalculatorContext } from '../../../contexts/CalculatorProvider';

function PillsFirstScreen(): React.ReactElement {
 const {
  setBackButtonText,
  setNextButtonText,
  setNextButtonAction,
  setBackButtonAction,
 } = useContext(CalculatorNavigationContext);

 const {
  homeRedirect,
  secondScreenRedirect,
  thirdScreenRedirect,
  onSelectChange,
  onValueChange,
  getValueInitialState,
  getSelectInitialState,
  setSelectedUnit,
 } = useContext(PillsContext);

 const {
  setHasCheckbox,
  setPageTitle,
  setQuestion,
  setCheckboxText,
  setUnitTypes,
  setCheckboxAction,
  checkboxValue,
 } = useContext(CalculatorContext);

 const unitTypes = [
  ...GramUnits.filter(
   unit =>
    ![UnitType.Kilogram, UnitType.KilogramPerMl].includes(unit.description),
  ),
  ...MolUnits,
  ...IEUnits,
 ];

 const setNavigationProps = () => {
  const setBackButtonProps = () => {
   setBackButtonText('Avbryt');
   setBackButtonAction(homeRedirect);
  };
  const setNextButtonProps = () => {
   setNextButtonText('Neste');
   setNextButtonAction(thirdScreenRedirect);
  };
  setBackButtonProps();
  setNextButtonProps();
 };

 const setCalculatorProps = () => {
  setHasCheckbox(true);
  setPageTitle('Tabletter o.I');
  setQuestion('Hva er den ordinerte dosen?');
  setCheckboxText('pr kg av pasientens kroppsvekt');
  setUnitTypes(unitTypes);
 };

 useEffect(() => {
  setNavigationProps();
  setCalculatorProps();
  // eslint-disable-next-line react-hooks/exhaustive-deps
 }, []);

 useEffect(() => {
  if (checkboxValue) {
   setCheckboxAction(() => setNextButtonAction(secondScreenRedirect));
  } else {
   setCheckboxAction(() => setNextButtonAction(thirdScreenRedirect));
  }
 }, [
  checkboxValue,
  secondScreenRedirect,
  setCheckboxAction,
  setNextButtonAction,
  thirdScreenRedirect,
 ]);

 return (
  <CalculatorComponent
   onValueChange={onValueChange}
   onSelectChange={value => {
    onSelectChange(value);
    setSelectedUnit(value);
   }}
   valueInitialState={getValueInitialState()}
   selectInitialState={getSelectInitialState()}
  />
 );
}

export default PillsFirstScreen;
